/** 회사 로고가 없을 때 쓰는 대체 마크(산 모양). 사이드바 브랜드와 MO 헤더가 공유. */
export function BrandMarkGlyph({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" aria-hidden="true">
      <path d="M3 17 L8 5 L11 11 L14 5 L19 17 Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <circle cx="11" cy="14" r="1.6" fill="currentColor" />
    </svg>
  );
}
